import type { MapaCargo, MapaCargoSecao } from '@/components/Configuracao/mapaCargos/mapaCargosTypes'

export type MapaCargoOverridesMap = Record<string, MapaCargoSecao[]>

export function mergeMapaCargoSecoes(
  base: MapaCargo,
  overrideSecoes?: MapaCargoSecao[] | null,
): MapaCargo {
  if (!overrideSecoes?.length) return base
  return { ...base, secoes: overrideSecoes }
}

export function mergeMapaCargos(
  cargos: MapaCargo[],
  overrides: MapaCargoOverridesMap,
): MapaCargo[] {
  return cargos.map((cargo) => mergeMapaCargoSecoes(cargo, overrides[cargo.id]))
}

export function resolveMapaCargo(
  id: string,
  cargos: MapaCargo[],
  overrides: MapaCargoOverridesMap = {},
): MapaCargo | undefined {
  const base = cargos.find((cargo) => cargo.id === id)
  if (!base) return undefined
  return mergeMapaCargoSecoes(base, overrides[id])
}

export function slugifyMapaCargoSecaoId(value: string): string {
  return value
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '')
    .slice(0, 120)
}

export function cloneMapaCargoSecoes(secoes: MapaCargoSecao[]): MapaCargoSecao[] {
  return secoes.map((secao) => ({
    id: secao.id,
    titulo: secao.titulo,
    atividades: [...secao.atividades],
  }))
}
